import { render } from "./UploadFilesModal.vue?vue&type=template&id=924e5262&scoped=true"
import script from "./UploadFilesModal.vue?vue&type=script&lang=js"
export * from "./UploadFilesModal.vue?vue&type=script&lang=js"

import "./UploadFilesModal.vue?vue&type=style&index=0&id=924e5262&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-924e5262"]])

export default __exports__